module.exports = __webpack_public_path__ + "static/img/pinpaibaozhang_icon.c4b5975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinpaibaozhang_icon.png
// module id = J9vC
// module chunks = 1